export enum DocsColors {
	PRIMARY = 'var(--color-docs-primary)',
	PRIMARY900 = 'var(--color-docs-primary-900)',
	PRIMARY800 = 'var(--color-docs-primary-800)',
	PRIMARY700 = 'var(--color-docs-primary-700)',
	PRIMARY600 = 'var(--color-docs-primary-600)',
	PRIMARY500 = 'var(--color-docs-primary-500)',
	PRIMARY400 = 'var(--color-docs-primary-400)',
	PRIMARY300 = 'var(--color-docs-primary-300)',
	PRIMARY200 = 'var(--color-docs-primary-200)',
	PRIMARY100 = 'var(--color-docs-primary-100)',
}
